import { oneLineTrim } from 'common-tags';

export const fetchDirections = (
    eventId,
    departureLocation,
    arrivalLocation
) => oneLineTrim`
    events/${eventId}/locations/directions/${departureLocation}/${arrivalLocation}
`;
